// @ts-ignore — CSS module sin tipos
import styles from './AdriAvatar.module.css';

interface AdriAvatarProps {
  /** Diámetro en px. */
  size?: number;
  /** Variante sobre fondo morado (cabecera del cajón). */
  light?: boolean;
  className?: string;
}

/** 051 — Avatar de Adri (PRD §7.3): decorativo, el nombre va al lado. */
const AdriAvatar = ({ size = 32, light = false, className = '' }: AdriAvatarProps) => (
  <span
    className={`${styles.avatar} ${light ? styles.light : ''} ${className}`}
    style={{ width: size, height: size, fontSize: Math.round(size * 0.48) }}
    aria-hidden="true"
    data-testid="adri-avatar"
  >
    A
  </span>
);

export default AdriAvatar;
